import React from 'react'
import { Link } from 'react-router-dom'
import NotificationsWidget from './notifyWIdget'

export const AuthorizedDropDownMeny = ({
  userTitle,
  onLogout,
}) => (
  <ul className="navbar-nav d-flex flex-row align-items-center">
    <li className="nav-item me-3">
      <NotificationsWidget />
    </li>
    <li className="nav-item dropdown">
      <a className="dropdown-toggle" data-bs-toggle="dropdown" data-trigger="hover">
        <i className="ti ti-user me-2"></i>
        <span className="d-none d-md-inline-block">{userTitle}</span>
      </a>
      <div className="dropdown-menu dropdown-menu-end mt-2">
        <Link to="/auth/change_password/" className="dropdown-item change_password_btn">
          <i className="ti ti-key me-2 ti-sm"/> Поменять пароль
        </Link>
        <a onClick={onLogout} className="dropdown-item">
          <i className="ti ti-logout me-2 ti-sm"/> Выход
        </a>
      </div>
    </li>
  </ul>
)

export const UnauthorizedDropDownMenu = () => (
  <span>
    <Link to="/auth/login" className="nav-link">
      <i className="ti ti-login rounded-circle me-1"/>
      <span className="align-middle">Вход</span>
    </Link>
  </span>
)